<template>
  <div class="w-full md:flex md:justify-center py-4 md:py-8">
    <section class="w-full max-w-7xl mx-auto px-5 py-2 md:p-4 lg:p-0">
      <div>
        <div
          class="w-full md:[400px] lg:w-[845px] mx-auto flex flex-col gap-[20px] md:gap-4 text-left md:text-center"
        >
          <h2 class="text-[24px] md:text-[35px] text-[#1f1f1f] font-semibold">
            Frequently Asked Questions
          </h2>
          <div class="flex flex-col gap-5 lg:gap-4">
            <div
              v-for="(item, index) in faqItem"
              :key="index"
              class="flex flex-col gap-[10px] text-left"
            >
              <div
                class="flex justify-between gap-2 md:pt-[5px] cursor-pointer"
                @click="toggleAccordin(index)"
              >
                <h2
                  class="w-[90%] text-[16px] md:text-[18px] lg:text-[18px] text-[#001c54] text-opacity-80"
                >
                  {{ item.title }}
                </h2>
                <div class="w-[20px] flex justify-center items-center">
                  <span v-if="this.activeAccordin !== index" class="">
                    <img
                    src="@/assets/nav/down_blue.svg"
                    class="!w-[16px] !h-[16px] object-contain"
                    alt="down arrow"
                  />
                  </span>
                  <span v-else class="">
                   <img
                    src="@/assets/nav/up_blue.svg"
                    class="!w-[16px] !h-[16px] object-contain"
                    alt="up arrow"
                  />
                  </span>
                </div>
              </div>

              <p
                class="text-[14px] pb-[10px] lg:text-md text-[#1f1f1f] w-[90%]"
                v-show="activeAccordin === index"
              >
                {{ item.content }}
              </p>
            </div>
          </div>
          <div class="w-full md:flex md:justify-center md:items-center py-2">
            <button
              class="w-full md:w-[150px] lg:w-[210px] bg-[#f8c300] border rounded-3xl py-[13px] button-cta"
              @click="viewMore"
              v-if="showMore"
            >
              View More
            </button>
            <button
              class="w-full md:w-[150px] lg:w-[210px] bg-[#f8c300] border rounded-3xl py-[13px] button-cta"
              @click="viewLess"
              v-else
            >
              View Less
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "ElectiveFaq",
  props: ["faq"],
  data() {
    return {
      electiveFaqs: [],
      activeAccordin: null,
      faqToShow: 3,
    };
  },
  async created() {
    this.faqList();
  },
  computed: {
    faqItem() {
      return this.electiveFaqs.slice(0, this.faqToShow);
    },
    showMore() {
      return this.faqToShow < this.electiveFaqs.length;
    },
  },
  methods: {
    toggleAccordin(index) {
      if (index === this.activeAccordin) {
        this.activeAccordin = null;
      } else {
        this.activeAccordin = index;
      }
    },
    viewMore() {
      this.faqToShow += 2;
    },
    viewLess() {
      this.faqToShow = 3;
    },
    async faqList() {
      await axios
        .get(`${process.env.VUE_APP_API}/faq/faq-list/?slug=${this.faq}`)
        .then((resp) => {
          if (resp.data.status == 200) {
            this.electiveFaqs = resp.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style></style>
